The role of the person.

Currently, two codes are defined:

- `Recruiter` indicates a person recruiting for the position.
- `HiringManager` indicates an employee that requested the position to be filled.
